import { render, staticRenderFns } from "./nodeIncomeExpenditure.vue?vue&type=template&id=0bd421a4&scoped=true&"
import script from "./nodeIncomeExpenditure.vue?vue&type=script&lang=js&"
export * from "./nodeIncomeExpenditure.vue?vue&type=script&lang=js&"
import style0 from "./nodeIncomeExpenditure.vue?vue&type=style&index=0&id=0bd421a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd421a4",
  null
  
)

export default component.exports